import { render } from "./tipomulta.vue?vue&type=template&id=5cf87b2f"
import script from "./tipomulta.vue?vue&type=script&lang=js"
export * from "./tipomulta.vue?vue&type=script&lang=js"

import "./tipomulta.vue?vue&type=style&index=0&id=5cf87b2f&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__